import * as React from "react";
import Card from "@mui/material/Card";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import CardHeader from "@mui/material/CardHeader";
import CardActions from "@mui/material/CardActions";
import VerifiedIcon from "@mui/icons-material/Verified";
import classes from "../Styles/ReadyToSellByCarrier.module.css";

const RTSByCarrierRTSCard = (props) => {
  const { id, agencyReadyToSellByCarrier } = props;
  const filteredData = agencyReadyToSellByCarrier.filter(
    (records) => records.carrierId === id && records.isReady === "true"
  );
  const getName = () => {
    const data = agencyReadyToSellByCarrier.filter(
      (records) => records.carrierId === id
    );
    return data[0]?.carrierName;
  };
  const getCount = () => {
    let results = 0;
    if (filteredData.length > 0) {
      let results = 0;
      if (filteredData.length > 0) {
        results = filteredData[0].totalByReadyStatus;
      } else {
        results = 0;
      }
      return results;
    } else {
      return results;
    }
  };
  const name = getName();
  const count = getCount();
  return (
    <Box sx={{ minWidth: 275, margin: 1 }}>
      <Card className={classes.gridItem} sx={{ maxWidth: 225 }}>
        <CardHeader
          avatar={
            <Avatar
              sx={{
                bgcolor: "rgb(76, 81, 77)",
              }}
              aria-label="carrier"
            >
              <VerifiedIcon />
            </Avatar>
          }
          title={name}
          subheader={`Ready to Sell: ${count}`}
        />
        <CardActions
          sx={{
            display: "flex",
            justifyContent: "center",

            marginTop: "auto",
          }}
        ></CardActions>
      </Card>
    </Box>
  );
};

export default RTSByCarrierRTSCard;
